import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const PlanCards = () => {
    const [activeLink, setActiveLink] = useState("starter-plan");
    const sliderRef = useRef(null);

    const handleLinkClick = (plan) => {
        switch (plan) {
            case "starter-plan":
                sliderRef.current.slickGoTo(0);
                break;
            case "silver-plan":
                sliderRef.current.slickGoTo(1);
                break;
            case "gold-plan":
                sliderRef.current.slickGoTo(2);
                break;
            case "platinum-plan":
                sliderRef.current.slickGoTo(3);
                break;
            default:
                break;
        }
        setActiveLink(plan);
    };

    console.log(sliderRef, "sliderRef");
    console.log(activeLink, "activeLink");
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
    };
    return (
        <div style={{ zIndex: "1000" }}>
            <Slider
                ref={(slider) => (sliderRef.current = slider)}
                {...settings}
                className="mx-2 py-2"
                draggable={false}
            >
                <Card
                    description=""
                    url="./images/store/plans_activate_starter.png"
                />
                <Card
                    description=""
                    url="./images/store/plans_activate_silver.png"
                />
                <Card
                    description=""
                    url="./images/store/plans_activate_gold.png"
                />
                <Card
                    description=""
                    url="./images/store/plans_activate_platinium.png"
                />
            </Slider>
            {/* navbar1 List */}
            <div className="App">
                <nav className="navbar1">
                    <ul className="navbar1-menu">
                        <li>
                            <a
                                href="#starter-plan"
                                className={
                                    activeLink === "starter-plan"
                                        ? "active"
                                        : ""
                                }
                                onClick={() => handleLinkClick("starter-plan")}
                            >
                                Starter Plan
                            </a>
                        </li>
                        <li>
                            <a
                                href="#silver-plan"
                                className={
                                    activeLink === "silver-plan" ? "active" : ""
                                }
                                onClick={() => handleLinkClick("silver-plan")}
                            >
                                Silver Plan
                            </a>
                        </li>
                        <li>
                            <a
                                href="#gold-plan"
                                className={
                                    activeLink === "gold-plan" ? "active" : ""
                                }
                                onClick={() => handleLinkClick("gold-plan")}
                            >
                                Gold Plan
                            </a>
                        </li>
                        <li>
                            <a
                                href="#platinum-plan"
                                className={
                                    activeLink === "platinum-plan"
                                        ? "active"
                                        : ""
                                }
                                onClick={() => handleLinkClick("platinum-plan")}
                            >
                                Platinum Plan
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
};

const Card = ({ description, url }) => {
    return (
        <div
            className="mx-1 card-style m-0 shadow-card shadow-card-m d-flex align-items-center position-relative"
            style={{
                height: "230px",
                backgroundImage: `url(${url})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "12px",
            }}
        >
            <h2
                className="font-38 font-700"
                style={{ color: "#C3C4FF", marginLeft: "35px" }}
            >
                {description}
            </h2>
        </div>
    );
};
